import { useLingui } from '@lingui/react/macro';

import { resolveMicDenialTarget } from './micPermission';

/**
 * Фраза для человека, которому не отдали микрофон, — с реальным путём к разрешению для его среды.
 *
 * <p>Хук, а не компонент, намеренно: в звонке подсказка живёт отдельной строкой под кнопками,
 * а в групповом войсе подменяет собой хинт про push-to-talk. Разметка у мест разная, текст один.
 */
export const useMicDenialHint = (): string => {
  const { t } = useLingui();
  const target = resolveMicDenialTarget();

  switch (target) {
    case 'native-ios':
      return t`media:mic.denied.nativeIos`;
    case 'native-android':
      return t`media:mic.denied.nativeAndroid`;
    case 'ios-browser':
      return t`media:mic.denied.iosBrowser`;
    case 'android-browser':
      return t`media:mic.denied.androidBrowser`;
    default:
      return t`media:mic.denied.desktop`;
  }
};
